'use client';

import React, { useCallback } from 'react';
import CheatAction from 'components/CheatAction';
import useZStore, { getUserNoteById } from 'utils/useZStore';
import { Bookmark } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Example } from '@/types/Example';
import { updateUserNote } from '@/utils/update-user-note';

interface IProps {
  cheat: Example;
  className?: string;
}

const BookmarkButton = (props: IProps) => {
  const { cheat, className } = props;
  // TO-DO: This is super inneficient, we may want to pass as prop
  const userNote = useZStore(getUserNoteById(cheat.id, true));
  const bookmarked = userNote?.bookmarked || false;

  // TO-DO: Reconsider creating a function for each button
  // or maube using an imported function that accepts is more intelligent
  const handleToggleBookmark = useCallback(
    (_e: React.MouseEvent) => {
      const newUserNote = {
        ...userNote,
        bookmarked: !bookmarked,
      };

      updateUserNote(newUserNote);
    },
    [bookmarked, userNote],
  );

  return (
    <CheatAction
      onClick={handleToggleBookmark}
      className={className}
      tooltip={bookmarked ? 'Unbookmark' : 'Bookmark'}
    >
      <Bookmark
        size={18}
        aria-label={bookmarked ? 'Unbookmark' : 'Bookmark'}
        className={cn('transition-stroke fill-gray-50 duration-150 ease-out', {
          'fill-yellow-300 stroke-yellow-500': bookmarked,
        })}
      />
    </CheatAction>
  );
};

export default BookmarkButton;
